import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { getRoleName } from "../../shared/utils/roleMapping";

export const getToken = (state) => state.auth.tokens?.access_token;
export const getIsAuthenticated = (state) =>
  !!state?.auth?.user && !!state?.auth?.tokens?.access_token;
export const getUserFullName = (state) => {
  const firstName = state.auth.user?.first_name || "";
  const lastName = state.auth.user?.last_name || "";
  return `${firstName} ${lastName}`.trim();
};
export const getUserInitials = (state) => {
  const firstName = state.auth.user?.first_name || "";
  return `${firstName.charAt(0)}`.toUpperCase();
};
export const getAccountType = (state) => {
  // If logged in via School Admin flow, always treat as School Admin
  if (state.auth.user?.account_type === "school") return "School Admin";

  const roleIds = state.auth.mdm?.role_ids || [];
  const roleMappings = CONFIG_VARS.roleMappings[1];

  if (!roleIds.length || !roleMappings) return null;

  const hierarchicalRoleIds = Object.keys(roleMappings)
    .map(Number)
    .sort((a, b) => a - b);

  for (const roleId of hierarchicalRoleIds) {
    if (roleIds.includes(roleId)) {
      return roleMappings[roleId];
    }
  }

  return null;
};
export const getUserLoginId = (state) => state.auth.user?.admission_id || "";
export const getUserCrnId = (state) => state.auth.user?.crnId || "";
export const getUserSchoolId = (state) => state.auth.user?.school_id || "";
